package com.karyadina.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.material3.ExperimentalMaterial3Api

@Composable
actual fun ImageThumbnail(
    imagePath: String,
    onView: () -> Unit,
    onRemove: () -> Unit,
    showRemoveButton: Boolean,
    modifier: Modifier
) {
    // Web stub - not implemented
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
actual fun ImageViewerDialog(
    imagePaths: List<String>,
    initialIndex: Int,
    onDismiss: () -> Unit
) {
    // Web stub - not implemented
}
